import React, { Component } from 'react';
import { connect } from 'react-redux';
import './Section.css';
import './Travel.css';
import accList from '../assets/accommodations.json';

const mapStateToProps = state => ({
  region: state.invitee.region,
  events: state.invitee.events,
});

const mapDispatchToProps = dispatch => ({});

const AccommodationList = ({ accommodations, region }) => {
  let i = 0;
  return (
    <div className="acc-list">
      {accommodations.map(acc => (
        <Accommodation a={acc} region={region} key={i++} />
      ))}
    </div>
  );
};

const Accommodation = ({ a, region }) => (
  <div className="acc-list-item">
    <div className="acc-name">
      <a href={a.link} target="_blank" rel="noopener noreferrer">
        {a.name}
      </a>
    </div>
    <span className="acc-desc">{a.description}</span>
    <span className="acc-price">
      Price: ~$
      {region.includes('us') ? a.price_usd + ' USD' : a.price_cad + ' CAD'}
    </span>
    <span className="acc-type">Type: {a.type}</span>
    <span className="acc-map">
      <a href={a.map_link} target="_blank" rel="noopener noreferrer">
        View on map
      </a>
    </span>
  </div>
);

const NYSection = ({ region }) => (
  <div className="travel-info-section">
    <h2>Southampton Accommodations</h2>
    <p>These are some hotels we've found within range of the wedding venue</p>
    <p>
      Hotels are likely the best option for 2 or 3 night stays while{' '}
      <a href="https://www.airbnb.ca/?locale=en">AirBnB</a> or{' '}
      <a href="https://www.homeaway.ca/">HomeAway</a> are more economic for
      longer stays
    </p>
    <p>
      <a href="https://bit.ly/2R8cAAN">
        Click here for an example AirBnB search
      </a>
    </p>
    <p>
      The prices listed below are quick estimates and you may find better
      pricing
    </p>
    <AccommodationList accommodations={accList.ny} region={region} />
    <h2>Transportation</h2>
    <p>Coming Soon</p>
    {/* <p>If you are going to be flying, the best airport to fly into is JFK.</p> */}
  </div>
);

const CASection = ({ region }) => (
  <div className="travel-info-section">
    <h2>Parksville Accommodations</h2>
    <p>
      We have reserved a block of rooms at Pacific Shores, the venue for this
      event. Call or email Pacific Shores and mention you're with the Dorsay
      wedding.
      <a href="tel:250-586-7262">250-586-7262</a>,{' '}
      <a href="mailto:GuestServices@PacificShoresBC.com">
        GuestServices@PacificShoresBC.com
      </a>{' '}
    </p>
    <p>
      If you'd like to stay longer there are a few available AirBnB houses in
      Parksville and Nanaimo.
    </p>
    <p>
      <a href="https://bit.ly/2Glv5vO">
        Click here for an example AirBnB search
      </a>
    </p>
    <AccommodationList accommodations={accList.ca} region={region} />
    <h2>Transportation</h2>
    <p>Coming Soon</p>
    {/* <p>If you are going to be flying, the best airport to fly into is JFK.</p> */}
  </div>
);

const Main = ({ sectionId, region, events }) => {
  return (
    <section id={sectionId} className="travel-section">
      <h1>Travel Info</h1>
      {Object.keys(events).includes('ny') ? (
        <NYSection region={region} />
      ) : null}
      {Object.keys(events).includes('ca') ? (
        <CASection region={region} />
      ) : null}
    </section>
  );
};

class Travel extends Component {
  componentWillMount() {
    this.sectionId = `section-${this.props.section}`;
  }

  render() {
    return <Main {...this.props} sectionId={this.sectionId} />;
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Travel);



// WEBPACK FOOTER //
// ./src/components/Travel.js